module.exports = __webpack_public_path__ + "img/obs_snow_150.39250dce.svg";